module.exports = __webpack_public_path__ + "hungry-ghost.11dd3348.jpg";


//////////////////
// WEBPACK FOOTER
// ./client/images/neighborhood/full/hungry-ghost.jpg
// module id = 662
// module chunks = 0